import { combineReducers } from "redux"

import { shellReducer } from "@containers/App/reducer"
import { footerReducer } from "@containers/Footer/reducer"
import { searchReducer } from "@containers/Search/reducer"
import { labsSearchReducer } from "@containers/LabsSearch/reducer"
import { categoryTreeReducer } from "@containers/CategoryTree/reducer"
import { locationsReducer } from "@containers/LocationPicker/reducer"
import { savingsPageReducer } from "@pages/SavingsPage/reducer"
import { cartPageReducer } from "@pages/CartPage/reducer"
import { addressPageReducer } from "@pages/AddressPage/reducer"
import { slotPageReducer } from "@pages/SlotPage/reducer"
import { abExperimentReducer } from "@containers/App/ABExperimentReducer/reducer"
import { prescriptionPageReducer } from "@pages/PrescriptionPage/reducer"
import { dioAttachPrescriptionReducer } from "@pages/DioAttachPrescription/reducer"
import { dioOrderPreviewReducer } from "@pages/DioOrderPreview/reducer"
import { dioRxProcessingReducer } from "@pages/DioRxProcessing/reducer"
import { dioAddressPageReducer } from "@pages/DioAddressPage/reducer"
import { corporateLabsBookingPageReducer } from "@pages/Corporate/LabsBookingPage/reducer"
import { addressFlowReducer } from "@flows/AddressDialog/reducer.js"
import { corporateDashboardReducer } from "@pages/Corporate/CorporateDashboard/reducer"
import { corporateBookingSuccessPageReducer } from "@pages/Corporate/BookingSuccessPage/reducer"
import { inventoryReducer } from "@pages/Labs/InventoryPage/reducer"
import { shipmentPageReducer } from "@pages/ShipmentPage/reducer"
import { cartSummaryPageReducer } from "@pages/CartSummaryPage/reducer"
import { cartPaymentPageReducer } from "@pages/CartPayment/reducer.js"
import { orderSuccessReducer } from "@pages/OrderSuccess/reducer"
import { labDetailsPageReducer } from "@pages/Labs/LabDetailsPage/reducer"
import { partnerOffersReducer } from "@pages/PartnerOffersPage/reducer"
import { offerDetailPageReducer } from "@pages/OfferDetailPage/reducer"
import { selfServeLoginPageReducer } from "@pages/Corporate/SelfServe/Login/reducer"
import { selfServeLeadPageReducer } from "@pages/Corporate/SelfServe/LeadPage/reducer"
import { selfServeSlotSelectionReducer } from "@containers/Corporate/SelfServe/SlotSelection/reducer"
import { selfServeBookingSuccessPageReducer } from "@pages/Corporate/SelfServe/BookingSuccess/reducer"
import { transactionHistoryReducer } from "@pages/Corporate/TransactionHistoryPage/reducer"
import { leadGenReducer } from "@pages/LeadGenPage/reducer"

// import loadableConfigReducer from "./loadableConfigReducer"
// /**
//  * @description A 'Reducer Manager' object, which keeps track of all the registered reducers and exposes a reduce() function. For detailed info :- https://redux.js.org/usage/code-splitting#using-a-reducer-manager
//  */

// function createReducerManager() {
//     // Create an object which maps keys to reducers
//     const reducers = {
//         loadableConfigReducer,
//         shellReducer,
//     }

//     // Create the initial combinedReducer
//     let reducerObj = combineReducers(reducers)

//     // An array which is used to delete state keys when reducers are removed
//     let keysToRemove = []

//     return {
//         getReducerMap: () => combineReducers(reducers),
//         // The root reducer function exposed by this object

//         // This will be passed to the store
//         reduce: (state, action) => {
//             // If any reducers have been removed, clean up their state first
//             if (keysToRemove.length > 0) {
//                 state = { ...state }
//                 for (let key of keysToRemove) {
//                     delete state[key]
//                 }
//                 keysToRemove = []
//             }

//             // Delegate to the combined reducer
//             return reducerObj(state, action)
//         },

//         // Adds a new reducer with the specified key
//         add: (reducer) => {
//             for (let key in reducer) {
//                 if (!key) {
//                     return
//                 }

//                 // We will skip a step if the reducer is already present
//                 if (reducers[key]) {
//                     continue
//                 }

//                 // Add the reducer to the reducer mapping
//                 reducers[key] = reducer[key]
//             }

//             // Generate a new combined reducer
//             return combineReducers(reducers)
//         },

//         // Removes a reducer with the specified key
//         remove: (key) => {
//             if (!key || !reducers[key]) {
//                 return
//             }

//             // Remove it from the reducer mapping
//             delete reducers[key]

//             // Add the key to the list of keys to clean up
//             keysToRemove.push(key)

//             // Generate a new combined reducer
//             return combineReducers(reducers)
//         },
//     }
// }
export default combineReducers({
    footerReducer,
    searchReducer,
    labsSearchReducer,
    categoryTreeReducer,
    locationsReducer,
    savingsPageReducer,
    shellReducer,
    cartPageReducer,
    addressPageReducer,
    slotPageReducer,
    abExperimentReducer,
    prescriptionPageReducer,
    dioAttachPrescriptionReducer,
    dioOrderPreviewReducer,
    dioRxProcessingReducer,
    dioAddressPageReducer,
    corporateLabsBookingPageReducer,
    addressFlowReducer,
    corporateDashboardReducer,
    corporateBookingSuccessPageReducer,
    inventoryReducer,
    shipmentPageReducer,
    cartSummaryPageReducer,
    cartPaymentPageReducer,
    orderSuccessReducer,
    labDetailsPageReducer,
    partnerOffersReducer,
    offerDetailPageReducer,
    selfServeLoginPageReducer,
    selfServeLeadPageReducer,
    selfServeSlotSelectionReducer,
    selfServeBookingSuccessPageReducer,
    transactionHistoryReducer,
    leadGenReducer,
})
